'use client';

import SimpleHeader from '@components/SimpleHeader';
import {
  GeneralError as GeneralErrorTemplate,
  type GeneralErrorProps
} from '@coolblue-development/next-error/client';
import { getLogger } from '@coolblue-development/react-logging';
import { useEffect } from 'react';

export default function Error(props: GeneralErrorProps) {
  useEffect(() => {
    getLogger().error('GeneralError component rendered due to an uncaught exception.', props.error);
  }, [props]);

  return (
    <>
      <SimpleHeader />
      <GeneralErrorTemplate {...props} />
    </>
  );
}
